<template>
  <div>
    <v-card class="card-shadow border-radius-xl">
      <v-card-title class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <span class="font-weight-bold text-h5 text-typo"
            >保險級距 ({{ year }})</span
          >
        </div>
        <div class="d-flex align-center">
          <v-text-field
            v-model.number="filterAmount"
            type="number"
            label="金額過濾"
            class="
              mr-2
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            hide-details
            dense
            outlined
            style="max-width: 160px"
          />
          <v-btn
            elevation="0"
            :ripple="false"
            height="40"
            class="
              mr-4
              font-weight-bold
              text-capitalize
              btn-ls btn-default
              bg-gradient-default
              py-3
              px-4
            "
            @click="filterAmount = null"
            >清除</v-btn
          >
          <v-select
            v-model="year"
            :items="availableYears"
            label="年份"
            class="
              mr-4
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            hide-details
            dense
            outlined
            style="max-width: 140px"
            @change="fetchBrackets"
          />
          <v-btn
            elevation="0"
            :ripple="false"
            height="40"
            class="
              mr-2
              font-weight-bold
              text-capitalize
              btn-ls btn-success
              bg-gradient-success
              py-3
              px-6
            "
            @click="uploadDialog = true"
            >上傳檔案</v-btn
          >
          <v-btn
            elevation="0"
            :ripple="false"
            height="40"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-primary
              bg-gradient-primary
              py-3
              px-6
            "
            :loading="loading"
            @click="fetchBrackets"
            >重新整理</v-btn
          >
        </div>
      </v-card-title>

      <v-card-text class="px-0 py-0">
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :loading="loading"
          class="table"
          hide-default-footer
          disable-pagination
          :items-per-page="-1"
          mobile-breakpoint="0"
        >
          <template v-slot:item.bracket_label="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.bracket_label || item.bracket_min + "-" + item.bracket_max
              }}</span>
            </div>
          </template>
          <template v-slot:item.bracket_min="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.bracket_min
              }}</span>
            </div>
          </template>
          <template v-slot:item.bracket_max="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.bracket_max
              }}</span>
            </div>
          </template>
          <template v-slot:item.org_labor_fee="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.org_labor_fee
              }}</span>
            </div>
          </template>
          <template v-slot:item.org_health_fee="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.org_health_fee
              }}</span>
            </div>
          </template>
          <template v-slot:item.org_pension_fee="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.org_pension_fee
              }}</span>
            </div>
          </template>
          <template v-slot:item.org_total="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.org_labor_fee + item.org_health_fee + item.org_pension_fee
              }}</span>
            </div>
          </template>
          <template v-slot:item.personal_labor_fee="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.personal_labor_fee
              }}</span>
            </div>
          </template>
          <template v-slot:item.personal_health_fee="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.personal_health_fee
              }}</span>
            </div>
          </template>
          <template v-slot:item.personal_pension_fee="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.personal_pension_fee
              }}</span>
            </div>
          </template>
          <template v-slot:item.personal_total="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">{{
                item.personal_labor_fee + item.personal_health_fee
              }}</span>
            </div>
          </template>
        </v-data-table>

        <div
          v-if="!loading && items.length === 0"
          class="pa-6 text-center text-body"
        >
          無資料
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="uploadDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 font-weight-bold"
          >上傳保險級距檔案</v-card-title
        >
        <v-card-text>
          <v-file-input
            v-model="selectedFile"
            label="選擇 Excel 檔案"
            accept=".xls,.xlsx"
            prepend-icon="mdi-file-excel"
            show-size
            :error-messages="uploadError"
            class="mt-4"
          />
          <v-text-field
            v-model.number="uploadYear"
            type="number"
            label="年份"
            class="mt-2"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeUploadDialog" :disabled="uploading"
            >取消</v-btn
          >
          <v-btn
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-primary
              bg-gradient-primary
              py-3
              px-6
            "
            @click="uploadFile"
            :loading="uploading"
            :disabled="!selectedFile"
            >上傳</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "InsuranceBrackets",
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),
      filterAmount: null,
      items: [],
      uploadDialog: false,
      uploading: false,
      selectedFile: null,
      uploadYear: new Date().getFullYear(),
      uploadError: "",
      headers: [
        {
          text: "級距",
          value: "bracket_label",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "最低",
          value: "bracket_min",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "最高",
          value: "bracket_max",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "雇主-勞保",
          value: "org_labor_fee",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "雇主-健保",
          value: "org_health_fee",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "雇主-勞退",
          value: "org_pension_fee",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "雇主合計",
          value: "org_total",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "個人-勞保",
          value: "personal_labor_fee",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "個人-健保",
          value: "personal_health_fee",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        // {
        //   text: "個人-勞退",
        //   value: "personal_pension_fee",
        //   sortable: false,
        //   class: "text-secondary font-weight-bolder opacity-7 black--text",
        // },
        {
          text: "個人合計",
          value: "personal_total",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("user", ["userToken"]),
    availableYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      // Generate years from 2020 to 20 years later
      for (let y = 2020; y <= currentYear + 5; y++) {
        years.push(y);
      }
      return years.sort((a, b) => a - b);
    },
    filteredItems() {
      if (
        this.filterAmount === null ||
        this.filterAmount === undefined ||
        this.filterAmount === ""
      ) {
        return this.items;
      }
      const amount = Number(this.filterAmount);
      if (Number.isNaN(amount)) return this.items;
      return this.items.filter(
        (r) =>
          Number(r.bracket_min) <= amount && amount <= Number(r.bracket_max)
      );
    },
  },
  mounted() {
    this.fetchBrackets();
  },
  methods: {
    async fetchBrackets() {
      try {
        this.loading = true;
        const base = process.env.VUE_APP_API_URL || "";
        const url = `${base}/api/insurance-brackets?year=${encodeURIComponent(
          this.year
        )}`;
        const res = await fetch(url, {
          method: "GET",
          headers: {
            accept: "application/json",
            ...(this.userToken
              ? { Authorization: `Bearer ${this.userToken}` }
              : {}),
          },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        this.items = Array.isArray(json?.data) ? json.data : [];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch insurance brackets:", err);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    closeUploadDialog() {
      this.uploadDialog = false;
      this.selectedFile = null;
      this.uploadError = "";
      this.uploadYear = this.year;
    },
    async uploadFile() {
      if (!this.selectedFile) {
        this.uploadError = "請選擇檔案";
        return;
      }
      try {
        this.uploading = true;
        this.uploadError = "";
        const base = process.env.VUE_APP_API_URL || "";
        const url = `${base}/api/insurance-brackets/upload?year=${encodeURIComponent(
          this.uploadYear
        )}`;

        const formData = new FormData();
        formData.append("file", this.selectedFile);

        const res = await fetch(url, {
          method: "POST",
          headers: {
            accept: "application/json",
            ...(this.userToken
              ? { Authorization: `Bearer ${this.userToken}` }
              : {}),
          },
          body: formData,
        });

        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.message || `HTTP ${res.status}`);
        }

        const json = await res.json();
        alert(`上傳成功！${json.message || ""} (共 ${json.count || 0} 筆)`);

        this.closeUploadDialog();
        if (this.uploadYear === this.year) {
          await this.fetchBrackets();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Failed to upload file:", err);
        this.uploadError = err.message || "上傳失敗";
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>

<style scoped>
.table >>> thead th {
  white-space: nowrap;
  font-size: 1rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.025rem;
  color: #8392ab;
  opacity: 0.7;
  padding: 0.75rem 1.5rem;
  border-bottom: 0.0625rem solid #e9ecef;
}

.table >>> tbody tr:last-child td {
  border-bottom: 0;
}

.table >>> tbody td {
  padding: 0.75rem 1.5rem;
  border-bottom: 0.0625rem solid #e9ecef;
}

.table >>> tbody tr:hover {
  background: #f8f9fa;
}

.input-style {
  background-color: #f8f9fa;
  border-radius: 0.5rem;
}

.font-size-input {
  font-size: 0.875rem;
}

.text-light-input {
  color: #495057;
}

.placeholder-light::placeholder {
  color: #adb5bd;
}

.card-shadow {
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}

.border-radius-xl {
  border-radius: 1rem;
}
</style>
